import * as Yup from 'yup';
import moment from 'moment';

function isBeforeThanStartOrigin(value) {
  if (value.start_schedule && value.date) {
    if (value.start_schedule.indexOf('/') > -1) {
      let iniData = '';
      const iniSplit = value.start_schedule.split(' ');
      iniData = `${iniSplit[0].split('/').reverse().join('-')} ${iniSplit[1]}`;

      let fimData = '';
      const fimSplit = value.date.split(' ');
      fimData = `${fimSplit[0].split('/').reverse().join('-')} ${fimSplit[1]}`;

      const isBefore = moment(iniData).isBefore(fimData);

      return isBefore;
    }

    const isBefore = moment(value.start_schedule).isBefore(value.date, 'day');

    return isBefore;
  }

  return true;
}

function isValidDate(value) {
  if (value && !moment(value).isValid()) {
    return false;
  }

  return true;
}

// Destinations

function isBeforeThanStartDest(value) {
  if (value.start_schedule && value.date) {
    if (value.start_schedule.indexOf('/') > -1) {
      let iniData = '';
      const iniSplit = value.start_schedule.split(' ');
      iniData = `${iniSplit[0].split('/').reverse().join('-')} ${iniSplit[1]}`;

      let fimData = '';
      const fimSplit = value.date.split(' ');
      fimData = `${fimSplit[0].split('/').reverse().join('-')} ${fimSplit[1]}`;

      const isBefore = moment(iniData).isBefore(fimData);

      return isBefore;
    }

    const isBefore = moment(value.start_schedule).isBefore(value.date, 'day');

    return isBefore;
  }

  return true;
}

function isDateInMoreThanMinutesFromNow(minutes, date) {
  const dateInformed = moment(date);
  const minimumDate = moment().add(minutes, 'minutes');
  return !date || dateInformed.diff(minimumDate) > 0;
}

export function validateDateTime(value) {
  if (!moment(value, 'DD/MM/YYYY HH:mm', true).isValid()) {
    return false;
  }
  return true;
}

export const schema = Yup.object().shape({
  operationPreLoad: Yup.object()
    .nullable()
    .shape({
      value: Yup.number(),
    })
    .when('$isPreloadWithGRO', (isPreloadWithGRO, schema) => {
      if (isPreloadWithGRO === true) {
        return schema.shape({
          value: Yup.number().required('Operação pré-carga obrigatória'),
        });
      }
      return schema.nullable();
    }),
  maxTemperature: Yup.number()
    .nullable()
    .test(
      'both-or-neither',
      'Ambas as temperaturas devem ser preenchidas',
      function (value) {
        const { minTemperature } = this.parent;
        return (
          (value == null && minTemperature == null) ||
          (value != null && minTemperature != null)
        );
      }
    ),
  minTemperature: Yup.number()
    .nullable()
    .test(
      'both-or-neither',
      'Ambas as temperaturas devem ser preenchidas',
      function (value) {
        const { maxTemperature } = this.parent;
        return (
          (value == null && maxTemperature == null) ||
          (value != null && maxTemperature != null)
        );
      }
    )
    .test(
      'min-less-than-max',
      'A temperatura mínima não pode ser maior que a máxima',
      function (value) {
        const { maxTemperature } = this.parent;
        return (
          value == null || maxTemperature == null || value <= maxTemperature
        );
      }
    ),
  loadCreationNumber: Yup.number().required('Campo obrigatório'),
  client: Yup.object()
    .shape({
      id: Yup.number().required('Cliente Tomador obrigatório'),
    })
    .typeError('Cliente Tomador obrigatório'),
  dueDate: Yup.string()
    .required('Data de vencimento obrigatória')
    .test('date-valid-format', 'Data de vencimento inválida', value =>
      value ? validateDateTime(value) : true
    ),
  negotiator: Yup.array()
    .of(Yup.object())
    .min(1, 'Negociador obrigatório')
    .transform(value => {
      if (!value) {
        return undefined;
      }
      return value;
    })
    .required('Negociador obrigatório'),
  country: Yup.object()
    .shape({
      id: Yup.number().required(),
    })
    .typeError('País obrigatório'),
  phone: Yup.string()
    .transform(value => {
      if (!value) {
        return undefined;
      }
      return value.replace('_', '');
    })
    .matches(/^(\(\d{2}\)\d{5}-\d{4}|\d{11})$/, 'Formato incorreto!')
    .required('Telefone obrigatório!'),
  selectedVehicles: Yup.array()
    .of(Yup.object())
    .min(1, 'Selecione pelo menos um veículo!'),
  selectedImplements: Yup.array().when('selectedVehicles', (value, schema) => {
    const shouldRequire = value && value.filter(e => e.id === 18).length > 0;
    if (shouldRequire) {
      return schema
        .min(1, 'Selecione pelo menos um implemento!')
        .required('Selecione pelo menos um implemento!')
        .typeError('Selecione pelo menos um implemento!');
    }
    return schema;
  }),
  riskManager: Yup.mixed().when('tracked', (tracked, schema) => {
    if (tracked === true) {
      return Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.number().required(),
          })
        )
        .required('GR para rastreamento obrigatório')
        .typeError('GR para rastreamento obrigatório');
    }
    return schema.nullable();
  }),
  selectedBodies: Yup.array()
    .of(Yup.object())
    .min(1, 'Selecione pelo menos um tipo de carroceria!'),
  selectedDisposition: Yup.object()
    .shape({
      id: Yup.number().required('Disposição da carga obrigatório'),
    })
    .typeError('Disposição da carga obrigatório'),
  pallets: Yup.mixed().when('selectedDisposition', (value, schema) => {
    const shouldRequire = value && value?.name?.toLowerCase() === 'paletizada';
    if (shouldRequire) {
      return Yup.number()
        .positive('Pallets precisa ser um valor positivo')
        .max(128, 'Máximo de pallet é 128')
        .required('Número de pallets obrigatório')
        .typeError('Número de pallets obrigatório');
    }
    return schema.nullable();
  }),
  weight: Yup.number()
    .positive('Peso precisa ser um valor positivo')
    .required('Peso obrigatório')
    .typeError('Peso obrigatório'),
  product: Yup.object()
    .required('Produto obrigatório')
    .typeError('Produto obrigatório'),
  branchOffice: Yup.object()
    .required('Filial é obrigatória')
    .typeError('Filial é obrigatória'),

  origin: Yup.object()
    .required('Origem obrigatória')
    .shape({
      address: Yup.string()
        .required('Endereço obrigatório')
        .typeError('Endereço obrigatório'),
      city: Yup.object()
        .required('Cidade obrigatória')
        .typeError('Cidade obrigatória'),
      province: Yup.string()
        .required('UF obrigatório')
        .typeError('UF obrigatório'),
      scheduled_time: Yup.string()
        .required('Data máxima obrigatória')
        .typeError('Data máxima obrigatória')
        .test('is-end-a-valid-date', 'Data máxima da coleta inválida', value =>
          isValidDate(value)
        ),
      country: Yup.object()
        .required('País obrigatório')
        .typeError('País inválido'),
      zip_code: Yup.string().nullable(),
      start_schedule: Yup.string()
        .required('Data início obrigatória')
        .typeError('Data início inválida')
        .test('is-start-a-valid-date', 'Data de início inválida', value =>
          isValidDate(value)
        ),
      lat: Yup.number()
        .required('Selecione um logradouro utilizando o seletor do google')
        .transform((currentValue, originalValue) =>
          originalValue === '' ? undefined : currentValue
        ),
      lng: Yup.number()
        .required('Selecione um logradouro utilizando o seletor do google')
        .transform((currentValue, originalValue) =>
          originalValue === '' ? undefined : currentValue
        ),
    })
    .when('$limitSchedule', (limitSchedule, schema) => {
      if (limitSchedule) {
        return schema.shape({
          scheduled_time: Yup.string().test(
            'is-end-date-more-than-30-mins-from-now',
            'Data máxima da coleta precisa ser no mínimo daqui a 30 minutos',
            value => isDateInMoreThanMinutesFromNow(30, value)
          ),
          start_schedule: Yup.string().test(
            'is-start-date-more-than-30-mins-from-now',
            'Data início da coleta precisa ser no mínimo daqui a 30 minutos',
            value => isDateInMoreThanMinutesFromNow(30, value)
          ),
        });
      }
      return schema;
    })
    .test(
      'is-before-than-start-schedule',
      'Data início da coleta não pode ser maior que Data máxima da coleta',
      value => isBeforeThanStartOrigin(value)
    ),


  destinations: Yup.array()
  .min(1, 'Informe pelo menos um destino')
  .required('Informe pelo menos um destino')
  .of(
    Yup.object()
      .shape({
        address: Yup.string()
          .required('Endereço obrigatório')
          .typeError('Endereço inválido'),
        city: Yup.object()
          .required('Cidade obrigatória')
          .typeError('Cidade inválida'),
        province: Yup.string()
          .required('Estado obrigatório')
          .typeError('Estado inválido'),
        scheduled_time: Yup.string()
          .required('Data máxima obrigatória')
          .typeError('Data máxima inválida')
          .test('is-end-a-valid-date', 'Data máxima inválida', value =>
            isValidDate(value)
          ),
        type: Yup.object()
          .shape({
            id: Yup.string().required('Ação obrigatória'),
          })
          .typeError('Ação inválida')
          .required('Ação obrigatória'),
        country: Yup.object()
          .required('País obrigatório')
          .typeError('País inválido'),
        start_schedule: Yup.string()
          .required('Data início obrigatória')
          .typeError('Data início inválida')
          .test('is-start-a-valid-date', 'Data de início inválida', isValidDate),
        lat: Yup.number()
          .required('Selecione um logradouro utilizando o seletor do google')
          .transform((currentValue, originalValue) =>
            originalValue === '' ? undefined : currentValue
          ),
        lng: Yup.number()
          .required('Selecione um logradouro utilizando o seletor do google')
          .transform((currentValue, originalValue) =>
            originalValue === '' ? undefined : currentValue
          ),
      })
      .when('$limitSchedule', (limitSchedule, schema) => {
        if (limitSchedule) {
          return schema.shape({
            scheduled_time: Yup.string().test(
              'is-end-date-more-than-30-mins-from-now',
              'Data máxima do destino precisa ser no mínimo daqui a 30 minutos',
              value => isDateInMoreThanMinutesFromNow(30, value)
            ),
            start_schedule: Yup.string().test(
              'is-start-date-more-than-30-mins-from-now',
              'Data início do destino precisa ser no mínimo daqui a 30 minutos',
              value => isDateInMoreThanMinutesFromNow(30, value)
            ),
          });
        }
        return schema;
      })
      .test(
        'is-before-than-start-schedule',
        'Data início não pode ser maior que Data máxima',
        value => isBeforeThanStartDest(value)
      )
  ),
  cargoValue: Yup.number()
    .required('O valor da carga é obrigatório')
    .positive('O valor da carga deve ser um número positivo maior que 0')
    .moreThan(0, 'O valor da carga deve ser maior que 0.00'),
  costCenter: Yup.object()
    .required('Centro de custo obrigatório')
    .typeError('Centro de custo inválido'),
  negotiation: Yup.object()
    .shape({
      id: Yup.number().required('Campo obrigatório'),
    })
    .required('Negociação obrigatório')
    .typeError('Negociação inválida'),
  crt: Yup.string().nullable().max(50, 'Valor máximo de 50 caracteres'),
  pcp_observation: Yup.string().max(1000, 'Máximo 1000 caracteres'),
  freight_exchange: Yup.number()
    .transform((value, originalValue) => {
      return Number(originalValue);
    }, 'Informe cotação válida')
    .typeError('Informe cotação válida'),
  clientOrderNumber: Yup.string()
    .max(25, 'Valor máximo de 25 caracteres')
    .nullable(),
});

export const ValidatorExtraFields = Yup.array().of(
  Yup.object().shape({
    label: Yup.string()
      .min(3, 'Mínimo 3 caracteres')
      .required('Campo obrigatório')
      .typeError('Campo inválido'),
    value: Yup.string().required('Campo obrigatório'),
  })
);

export default schema;
